import reducer from "./reducer";
export { default as PollSettings } from "./components/index";
export { default as pollSettingsReducerName } from "./constants";
export default reducer;
